/*
 * @Author: ruiwang
 * @Date: 2024-02-25 12:37:13
 * @Last Modified by: ruiwang
 * @Last Modified time: 2024-02-29 17:54:38
 */
export const options1 = [
    ['メールアドレス（ログインID）', 'xukejp@yahoo.co.jp'],
    ['パスワード ', '********'],
    ['名前', '東京　太郎'],
    ['フリガナ', 'トウキョウ　タロウ'],
    ['生年月日', '29362'],
    ['住所', '東京都荒川区荒川５丁目１０ー２０'],
    ['秘密質問：好きな食べ物', 'イチゴ'],
    ['電話', '123456789']
];
export const options2 = [
    ['投資経験', '国内株式'],
    ['投資経験（年数）', '１～３'],
    ['金融資産（万円）', '4０００'],
    ['職業等', '会社員'],
    ['年収（万円）', '１０００'],
    ['投資方針※（複数可）', '短中期投資、資産分散'],
    ['証券口座の有無', '有'],
    ['余剰資金の運用である', 'はい'],
    ['元本毀損で生活に支障', ' いいえ']
];
export const options3 = [
    ['金融機闃名', '三菱UFJ銀行'],
    ['支店名 ', '青山支店'],
    ['口座種別', '普通口座'],
    ['口座番号', '1234567'],
    ['振込先名義人', 'インスタキャッシュ(力']
];
export const options4 = [
    ['金融機闃名', 'SBI新生銀行'],
    ['支店名 ', '本店'],
    ['口座種別', '普通口座'],
    ['口座番号', '6423***'],
    ['口座名義人', 'トウキョウ　タロウ']
];
export const genOptions = (options) => {
    const opts = options.map(item => {
        const [label, value] = item;
        return {
            label,
            value,
        };
    });
    return opts;
};
